<div fxLayoutGap="10px" *ngIf="showCortex" [style.margin-bottom]="'1em'">
    <mat-slide-toggle color="primary" [checked]="syncCortexEnabled" (change)="syncCortexChange($event)"  aria-labelledby="Ajouter un tag spécial [sync-cortex] : l'entité sera synchronisée avec Cortex">
        Synchro Cortex
    </mat-slide-toggle>

    <ng-content></ng-content>
</div>
<mat-form-field class="syn--full-width" appearance="outline">
    <mat-label>Ajouter un tag</mat-label>
    <input matInput #input [matAutocomplete]="auto" [formControl]="searchTerm" placeholder="Ajouter un tag">
    <mat-hint align="end">
        {{input.value?.length || 0}}/{{MAX_TAG_LENGTH}}
    </mat-hint>
</mat-form-field>
<div *ngIf="searchTerm.status === 'INVALID'" class="syn-drop-icon syn-marginbox--bottom">
    <mat-icon class="syn-text--danger" svgIcon="alert-outline"></mat-icon> Un tag doit contenir entre {{ MIN_TAG_LENGTH }} et {{ MAX_TAG_LENGTH }} caractères et peut être composé de lettres, chiffres, tirets (-) et underscores (_) avec un caractère alphanumérique au début et
    à la fin.
</div>


<mat-autocomplete #auto="matAutocomplete">
    <mat-option (onSelectionChange)="onSelectionChange($event, tag.name)" *ngFor="let tag of filteredTags | async" [value]="tag.name">
        {{ tag.name }} ({{ tag.count }})
    </mat-option>
    <mat-option *ngIf="showAddMessage" (click)="addTag(searchTerm.value)" [value]="searchTerm.value">
        Cliquez ici pour ajouter le tag <span class="font-bold">{{ searchTerm.value }}</span> pour la première fois
    </mat-option>
</mat-autocomplete>

<!--TAG List-->
<mat-chip-listbox>
    <mat-chip disableRipple *ngFor="let tag of tags" [matTooltip]="tag" (removed)="removeTag(tag)">
        {{ tag }}
        <mat-icon matChipRemove svgIcon="close-circle"></mat-icon>
    </mat-chip>
</mat-chip-listbox>
